import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TipoAgregacionService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getTipoAgregacion(): Observable<any> {
    return this.http.get(this.baseUrl + 'parTipoAgregaciones', { headers: this.header(this.token) });
  }

  getTipoAgregacionActivo(): Observable<any> {
    return this.http.get(this.baseUrl + 'parTipoAgregacionActivos', { headers: this.header(this.token) });
  }
  
  getTipoAgregacionById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getParTipoAgregacionById/' + id, { headers: this.header(this.token) });
  }

  postTipoAgregacion(TipoAgregacion: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parTipoAgregacion', TipoAgregacion, { headers: this.header(this.token) });
  }

  putTipoAgregacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parTipoAgregacion', bodyString, { headers: this.header(this.token) });
  }

  deleteTipoAgregacion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parTipoAgregacion/' + id, { headers: this.header(this.token) });
  }
  
}